/**
 * Determines the visibility of an element in the viewport.
 * @param {Element} el - The DOM element to check.
 * @param {Object} [opts] - Optional thresholds.
 * @param {number} [opts.top=0] - Pixels to offset from the top.
 * @param {number} [opts.bottom=0] - Pixels to offset from the bottom.
 * @returns {'above'|'visible'|'below'}
 */
function getElementViewportState(el, opts = {}) {
	const rect = el.getBoundingClientRect();
	const topThreshold = opts.top || 0;
	const bottomThreshold = opts.bottom || 0;
	const viewportHeight = window.innerHeight;

	if (rect.bottom < topThreshold) {
		return 'above';
	}
	if (rect.top > viewportHeight - bottomThreshold) {
		return 'below';
	}
	return 'visible';
}

module.exports = getElementViewportState;